<template>
  <div class="idCode">
    <div class="container">
      <div class="title">
        <div class="pic"></div>
        <div class="words">身份码相关问题</div>
      </div>
      <div class="line"></div>
      <div class="main">
        <div class="first">
          <div class="ques">一、金箱身份码到底是什么</div>
          <div class="content">
            金箱云仓系统，所有业务在开始之前，都要对相关人
            员进行身份识别，以保证业务开展的安全性，而金箱
            身份码则是用户身份识别的唯一凭证。
          </div>
        </div>
        <div class="second">
          <div class="ques">二、什么时候用</div>
          <div class="content">
            在做各项业务之前，需要出示身份码表明身份，再进 行后续的操作。
          </div>
        </div>
        <div class="third">
          <div class="ques">三、身份码能否帮刷</div>
          <div class="content">
            金箱身份码是个人身份凭证，不可以让其他人以任何
            形式代刷；如有代刷引起金融案件，将依法对相关人 员进行追责。
          </div>
        </div>
        <div class="furth">
          <div class="ques">四、相关责任风险</div>
          <div class="content">
            金箱身份码会全程记录业务操作人的相关信息，所有
            的操作，也会将责任具体化到相应的业务人员；身份
            码具有时效性，有效期为5分钟；身份码会自动动态 的刷新。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "idCode",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.idCode {
  width: 100%;
  height: 100vh;
  background: #f2f3f7;
  overflow: hidden;
}
.container {
  width: 670px;
  height: 1126px;
  background: #ffffff;
  margin: 40px;
  border-radius: 16px;
  overflow: hidden;
}
.title {
  height: 48px;
  margin: 32px 0 0 32px;
  div {
    float: left;
  }
}
.pic {
  width: 48px;
  height: 48px;
  background: url("../../assets/id.png");
  background-size: contain;
}
.words {
  font-size: 32px;
  color: #000000;
  font-weight: bold;
}
.line {
  margin: 24px auto !important;
  width: 606px;
  height: 1px;
  background: #e2e4ea;
}
.main {
  width: 598px;
  height: 796px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .first {
  }
  .second {
  }
  .third {
    .first();
  }
  .furth {
    .first();
  }
}
.ques {
  height: 40px;
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 28px;
}
.content {
  font-size: 26px;
}
</style>
